import React from "react";
import {
  Button,
  Card,
  Form,
  Input,
  notification,
  Popconfirm,
  Transfer
} from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { selectAllUsers } from "../../../../redux/selectors/users";
import { createStudentsGroup } from "../../../../redux/actions/groups";
import { selectCurrentUser } from "../../../../redux/selectors/auth";

class UserTransferComponent extends React.Component {
  state = {
    targetKeys: [this.props.currentUser.uid],
    selectedKeys: [],
    nombreGrupo: "",
    message: false,
    disabled: false,
    visible: false
  };

  openNotificationWithIcon = type => {
    notification[type]({
      message: "Grupo Añadido",
      description: "Se ha añadido exitosamente el grupo a la plataforma.",
      duration: 0
    });
  };

  handleChange = nextTargetKeys => {
    if (nextTargetKeys.length >= 8) {
      this.setState({ message: true });
    } else {
      this.setState({ targetKeys: nextTargetKeys });
    }
  };

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys]
    });
  };

  render() {
    const {
      targetKeys,
      selectedKeys,
      disabled,
      message,
      nombreGrupo,
      visible,
      pregunta
    } = this.state;
    const {
      currentUser,
      isCreatingGroup,
      usersByCur,
      createStudentsGroup
    } = this.props;

    const disable =
      isCreatingGroup ||
      (currentUser.groupKey && currentUser.groupKey.length >= 3) ||
      targetKeys.length <= 2 ||
      nombreGrupo.length <= 2;

    return (
      <React.Fragment>
        <Transfer
          listStyle={{ minWidth: "80%" }}
          dataSource={usersByCur}
          titles={["Alumnos", "Mi Grupo"]}
          targetKeys={targetKeys}
          selectedKeys={selectedKeys}
          onChange={this.handleChange}
          onSelectChange={this.handleSelectChange}
          disabled={currentUser.groupKey && currentUser.groupKey.length >= 3}
          render={item =>
            `${item.nombre} ${item.nivel}${item.identificadorNivel}`
          }
        />

        {message && <div>No puede ser mas que 7 alumnos ni menos que 3</div>}
        <Form.Item>
          <Input
            disabled={
              (currentUser.groupKey && currentUser.groupKey.length >= 3) ||
              disabled
            }
            placeholder="Añade un nombre de grupo"
            onChange={evt => this.setState({ nombreGrupo: evt.target.value })}
          />
        </Form.Item>

        <Popconfirm
          visible={!disable && visible}
          title="Seguro que quieres crear tu grupo? recuerda que debe ser de mas de 3 o mas alumnos y menos de 7"
          onConfirm={() => {
            if (disable) {
              return null;
            }
            this.openNotificationWithIcon("success");
            return createStudentsGroup(
              targetKeys,
              nombreGrupo,
              currentUser.nivel,
              currentUser.identificadorNivel,
              currentUser.colegio,
              pregunta
            );
          }}
          onCancel={e => {
            message.error("Click on No");
          }}
          okText="Si"
          cancelText="No"
        >
          <Button
            onClick={() => this.setState({ visible: true })}
            disabled={disable}
          >
            Crear Grupo
          </Button>
        </Popconfirm>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createStudentsGroup }, dispatch);

const mapStateToProps = state => {
  const currentUser = selectCurrentUser(state);
  const allUsers = selectAllUsers(state);
  const usersByCur = allUsers.filter(
    user =>
      user.nivel === currentUser.nivel &&
      user.colegio === currentUser.colegio &&
      user.identificadorNivel === currentUser.identificadorNivel
  );

  return {
    usersByCur,
    currentUser
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserTransferComponent);
